/* HEMP HOUNDS — product hero interactivity (gallery + zoom, accordions, purchase plans, qty & pricing,
   add-to-cart → theme drawer, deal timer, sticky bar). Loaded as a STANDALONE asset (not a section
   {% javascript %} block) so it runs in isolation and can't be killed by a runtime error elsewhere in the
   shared, concatenated section-JS bundle. Self-inits on .hh-product-hero via DOMContentLoaded +
   shopify:section:load (data-hh-init guard). */
(function () {
  'use strict';
  /* `reduce` went with the gallery hover-zoom — it was that block's only consumer. Motion elsewhere in
     this file is CSS-driven, so prefers-reduced-motion is honoured by the stylesheet, not here. */
  var fine = matchMedia('(hover: hover) and (pointer: fine)').matches;

  function initHero(root) {
    if (!root || root.dataset.hhInit) return; root.dataset.hhInit = '1';
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var BASE = parseInt(root.dataset.base, 10) || 0;
    var CHEWS = parseInt(root.dataset.chews, 10) || 90;
    var SUB_OFF = (parseFloat(root.dataset.suboff) || 0) / 100;
    var FREE = parseInt(root.dataset.freeship, 10) || 0;
    var MONEY = root.dataset.moneyFormat || ('${' + '{amount}' + '}');  // Shopify money-format pattern, assembled from parts so theme-check doesn't read it as a Liquid output
    var BULK = []; try { BULK = JSON.parse(root.dataset.bulk || '[]'); } catch (e) {}
    var MIN = 1, MAX = 12, qty = 2, plan = 'once';

    function money(cents) {
      var v = (cents / 100).toFixed(2);
      return MONEY.replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    }
    function volOff(q) { var off = 0; BULK.forEach(function (t) { if (q >= t.qty && t.off > off) off = t.off; }); return off; }
    function planMul() { return plan === 'sub' ? (1 - SUB_OFF) : 1; }

    /* GALLERY — carousel: thumbs + arrows + swipe + keyboard, with index wrap-around */
    var stage = $('[data-gal-stage]'), thumbs = $$('[data-gal-thumbs] .gal-thumb'), slides = $$('[data-gal-stage] .gal-slide');
    var galN = slides.length, galI = 0;
    function setSlide(i) {
      if (galN) i = ((i % galN) + galN) % galN;   // wrap around either end
      galI = i;
      slides.forEach(function (s) { s.classList.toggle('is-active', +s.dataset.i === i); });
      thumbs.forEach(function (t) { var on = +t.dataset.i === i; t.classList.toggle('is-active', on); t.setAttribute('aria-current', on ? 'true' : 'false'); });
      centerActiveThumb(thumbs[i]);   // keep the active thumb in view, revealing neighbours (mobile has no arrows)
    }
    // scroll ONLY the thumb strip (never the page) so the active thumb sits centred — on mobile this replaces the
    // prev/next buttons: navigating the main image auto-advances the thumb carousel, and vice-versa.
    function centerActiveThumb(thumb) {
      if (!thumb || !thumbsWrap) return;
      var vert = thumbsWrap.scrollHeight > thumbsWrap.clientHeight + 2;
      var horiz = thumbsWrap.scrollWidth > thumbsWrap.clientWidth + 2;
      if (!vert && !horiz) return;
      var tr = thumb.getBoundingClientRect(), wr = thumbsWrap.getBoundingClientRect();
      if (vert) thumbsWrap.scrollBy({ top: (tr.top - wr.top) - (wr.height - tr.height) / 2, behavior: 'smooth' });
      else thumbsWrap.scrollBy({ left: (tr.left - wr.left) - (wr.width - tr.width) / 2, behavior: 'smooth' });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { setSlide(+t.dataset.i); }); t.addEventListener('mouseenter', function () { if (fine) setSlide(+t.dataset.i); }); });
    // thumb strip = a 6-up carousel: show 6 square thumbs; prev/next page through the rest, active only when >6
    var thumbsWrap = $('[data-gal-thumbs]'), tPrev = $('[data-gal-thumbs-prev]'), tNext = $('[data-gal-thumbs-next]');
    // The strip is a horizontal row at every width now, but read the computed direction rather than
    // assume it — --gal-th-max is a HEIGHT cap and must never be set on a row.
    function thumbVertical() {
      if (!thumbsWrap) return false;
      return getComputedStyle(thumbsWrap).flexDirection === 'column';
    }
    // The gallery sticks below #header-group, whose height varies with the announcement bar and the
    // shrink-on-scroll nav. Measure it instead of hard-coding, so the stage never tucks under the header.
    function sizeGalleryTop() {
      var gal = $('.gallery'), hdr = document.querySelector('#header-group');
      if (!gal || !hdr) return;
      var h = hdr.getBoundingClientRect().height;
      if (h > 0) gal.style.setProperty('--hh-gal-top', Math.round(h + 24) + 'px');
    }
    function updateThumbNav() {
      if (!tPrev || !tNext || !thumbsWrap) return;
      var vert = thumbsWrap.scrollHeight > thumbsWrap.clientHeight + 2;
      var pos = vert ? thumbsWrap.scrollTop : thumbsWrap.scrollLeft;
      var max = (vert ? thumbsWrap.scrollHeight - thumbsWrap.clientHeight : thumbsWrap.scrollWidth - thumbsWrap.clientWidth);
      tPrev.disabled = pos <= 2;
      tNext.disabled = pos >= max - 2;
    }
    function sizeThumbStrip() {
      if (!thumbsWrap) return;
      var first = thumbsWrap.querySelector('.gal-thumb');
      if (first && thumbVertical()) {
        var cs = getComputedStyle(thumbsWrap), gap = parseFloat(cs.rowGap || cs.gap) || 11;
        var h = first.getBoundingClientRect().height;
        thumbsWrap.style.setProperty('--gal-th-max', (6 * h + 5 * gap) + 'px');   // exactly 6 thumbs tall
      } else { thumbsWrap.style.removeProperty('--gal-th-max'); }
      updateThumbNav();
    }
    function pageThumbs(dir) {
      if (!thumbsWrap) return;
      var vert = thumbsWrap.scrollHeight > thumbsWrap.clientHeight + 2;
      if (vert) thumbsWrap.scrollBy({ top: thumbsWrap.clientHeight * dir, behavior: 'smooth' });
      else thumbsWrap.scrollBy({ left: thumbsWrap.clientWidth * dir, behavior: 'smooth' });
    }
    if (tPrev) tPrev.addEventListener('click', function () { pageThumbs(-1); });
    if (tNext) tNext.addEventListener('click', function () { pageThumbs(1); });
    if (thumbsWrap) thumbsWrap.addEventListener('scroll', updateThumbNav, { passive: true });
    sizeThumbStrip(); sizeGalleryTop();
    window.addEventListener('resize', function () { sizeThumbStrip(); sizeGalleryTop(); });
    window.addEventListener('load', function () { sizeThumbStrip(); sizeGalleryTop(); });
    var galPrev = $('[data-gal-prev]'), galNext = $('[data-gal-next]');
    if (galPrev) galPrev.addEventListener('click', function () { setSlide(galI - 1); });
    if (galNext) galNext.addEventListener('click', function () { setSlide(galI + 1); });
    if (stage && galN > 1) {
      stage.setAttribute('tabindex', '0');
      stage.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') { e.preventDefault(); setSlide(galI - 1); } else if (e.key === 'ArrowRight') { e.preventDefault(); setSlide(galI + 1); } });
      var sx = 0, sy = 0, sw = false;
      stage.addEventListener('touchstart', function (e) { var t = e.changedTouches[0]; sx = t.clientX; sy = t.clientY; sw = true; }, { passive: true });
      stage.addEventListener('touchend', function (e) { if (!sw) return; sw = false; var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) setSlide(galI + (dx < 0 ? 1 : -1)); }, { passive: true });
    }
    /* (Hover-to-zoom on the gallery stage was removed at the client's request, desktop and mobile alike.
       It used to add `.is-zoom` on mouseenter/mousemove and track transform-origin to the cursor.) */

    /* DESCRIPTION read-more — CSS clamps `.buy-desc` to ~3 lines only under html.js (set synchronously in <head>),
       so with JS off the full text shows and no toggle appears. We reveal the toggle only when the text actually
       overflows, and expand via `.is-expanded`. Measured immediately AND again after fonts settle, so a slow or
       hanging web-font load never leaves the description stuck clipped with the toggle hidden. */
    var desc = $('[data-buy-desc]'), dToggle = $('[data-desc-toggle]');
    if (desc && dToggle) {
      var userToggled = false;
      dToggle.addEventListener('click', function () {
        userToggled = true;
        var expanded = desc.classList.toggle('is-expanded');
        dToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        dToggle.childNodes[0].nodeValue = expanded ? 'read less ' : 'read more ';
      });
      var measure = function () {
        if (userToggled) return;                     // never override a manual choice
        desc.classList.remove('is-expanded');        // clamped baseline to measure against
        if (desc.scrollHeight > desc.clientHeight + 2) {
          dToggle.hidden = false;                    // overflows -> offer "read more" (stays clamped)
        } else {
          desc.classList.add('is-expanded');         // fits in ~3 lines -> show all, keep toggle hidden
          dToggle.hidden = true;
        }
      };
      measure();                                     // deferred script: layout is ready now
      if (document.fonts && document.fonts.ready) { document.fonts.ready.then(measure); }
    }

    /* PLANS */
    var planCards = $$('[data-plans] .plan-card'), sellingInput = $('[data-selling-plan]');
    planCards.forEach(function (card) { card.addEventListener('click', function () {
      plan = card.dataset.plan;
      planCards.forEach(function (c) { var on = c === card; c.classList.toggle('is-active', on); c.setAttribute('aria-checked', on ? 'true' : 'false'); });
      if (sellingInput) { if (plan === 'sub' && card.dataset.planId) { sellingInput.value = card.dataset.planId; sellingInput.disabled = false; } else { sellingInput.value = ''; sellingInput.disabled = true; } }
      render();
    }); });

    /* QUANTITY + PRICING */
    var qtyVal = $('[data-qty-val]'), qtyInput = $('[data-qty-input]');
    var elNow = $('[data-price-now]'), elWas = $('[data-price-was]'), elSave = $('[data-price-save]');
    var elUnit = $('[data-qty-unit]');
    /* THE COUNTDOWN'S OWN PRICE (client request, Sep 2026). It used to quote the price bar verbatim;
       it can now quote a deal price of its own — "$34.99 struck / $32.99" — while everything that
       actually charges the shopper stays on the real Shopify price. The rule lives on the block as
       data-dp-* (set in hh-product-hero.liquid) and is read once here; the FIGURES are re-derived from
       the live total on every render, so no mode can drift out of step with the stepper.
       `mirror` is the old behaviour and the default, so an un-configured block is unchanged. */
    var dtNow = $('[data-dt-price-now]'), dtWas = $('[data-dt-price-was]'), dtSave = $('[data-dt-price-save]');
    var dtHost = $('.deal-timer');
    var dpAttr = function (n, d) { var v = dtHost && dtHost.getAttribute('data-dp-' + n); return v == null || v === '' ? d : v; };
    var DP_MODE = String(dpAttr('mode', 'mirror'));
    var DP_PCT  = (parseFloat(dpAttr('pct', 0)) || 0) / 100;
    var DP_OFF  = Math.round(parseFloat(dpAttr('off', 0)) || 0);   // cents off, per unit
    var DP_NOW  = Math.round(parseFloat(dpAttr('now', 0)) || 0);   // cents, per unit
    var DP_WAS  = Math.round(parseFloat(dpAttr('was', 0)) || 0);   // cents, per unit
    var DP_UNIT = dpAttr('unit', '1') !== '0';                     // multiply the typed figures by qty?
    var SAVE_WORD = String(dpAttr('word', 'save'));
    var atcPrice = $('[data-atc-price]'), psPrice = $('[data-ps-price]'), psWas = $('[data-ps-was]'), psMeta = $('[data-ps-meta]');
    var decBtn = $('[data-qty-dec]'), incBtn = $('[data-qty-inc]');
    function setQty(n) { qty = Math.max(MIN, Math.min(MAX, n)); render(); }

    /* DOG SIZE -> dose-aware supply + per-day price.
       The feeding guide doses by weight (1/2/3 chews a day), but the per-day price was hardcoded to one
       chew — true only for the smallest dogs, and understating the real cost 2-3x for everyone else.
       Picking a size makes both the per-day figure and the supply length honest. The choice is kept in
       localStorage so it carries across products and to the bundle section. */
    var dsWrap = $('[data-dog-size]'), dsOut = $('[data-ds-out]');
    var dsChips = dsWrap ? Array.prototype.slice.call(dsWrap.querySelectorAll('[data-ds-chip]')) : [];
    var DS_KEY = 'hh_dog_chews';
    var cpd = 0;                                   // chews/day; 0 = not chosen yet
    var doses = dsChips.map(function (c) { return parseFloat(c.getAttribute('data-chews')) || 1; });
    var minCpd = doses.length ? Math.min.apply(null, doses) : 1;
    var maxCpd = doses.length ? Math.max.apply(null, doses) : 1;
    function paintChips() {
      dsChips.forEach(function (c) {
        var on = cpd > 0 && parseFloat(c.getAttribute('data-chews')) === cpd;
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    function setDogSize(v, persist) {
      cpd = v > 0 ? v : 0;
      if (persist) { try { localStorage.setItem(DS_KEY, String(cpd)); } catch (e) {} }
      paintChips(); render();
    }
    dsChips.forEach(function (c) {
      c.addEventListener('click', function () {
        var v = parseFloat(c.getAttribute('data-chews')) || 1;
        setDogSize(v === cpd ? 0 : v, true);       // tapping the active chip clears it
      });
    });
    if (dsChips.length) {
      var saved = 0;
      try { saved = parseFloat(localStorage.getItem(DS_KEY)) || 0; } catch (e) {}
      if (saved > 0 && doses.indexOf(saved) !== -1) cpd = saved;   // ignore a stale dose this product doesn't offer
      paintChips();
    }
    // Days a given number of cartons lasts at the chosen dose.
    function supplyDays(cartons, per) { return Math.round(cartons * CHEWS / per); }
    if (decBtn) decBtn.addEventListener('click', function () { setQty(qty - 1); });
    if (incBtn) incBtn.addEventListener('click', function () { setQty(qty + 1); });

    function render() {
      var off = volOff(qty);
      var total = Math.round(BASE * qty * (1 - off) * planMul());
      var was = BASE * qty;
      var unit = Math.round(total / qty);
      var save = was - total;
      if (qtyVal) qtyVal.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
      if (decBtn) decBtn.disabled = qty <= MIN;
      if (incBtn) incBtn.disabled = qty >= MAX;
      if (elUnit) elUnit.textContent = money(unit) + ' / carton · ' + (qty * CHEWS) + ' chews';
      if (elNow) elNow.textContent = money(total);
      if (elWas && elSave) { if (save > 1) { elWas.textContent = money(was); elWas.hidden = false; elSave.textContent = 'you save ' + money(save); elSave.hidden = false; } else { elWas.hidden = true; elSave.hidden = true; } }
      /* DEAL PRICE. Always starts from `total` — which already carries the bulk tier and the subscribe
         multiplier — so the bar tracks the stepper whichever mode it is in. `mirror` reproduces the old
         behaviour exactly, down to hiding the struck figure on the same `> 1` cent test, so the two
         halves of the box can never disagree about whether there is a saving to show. */
      if (dtNow) {
        var dMul = DP_UNIT ? qty : 1;
        var dNow = total, dWas = was;
        if (DP_MODE === 'percent') { dWas = total; dNow = Math.round(total * (1 - DP_PCT)); }
        else if (DP_MODE === 'amount') { dWas = total; dNow = total - (DP_OFF * dMul); }
        else if (DP_MODE === 'fixed') {
          dWas = DP_WAS > 0 ? DP_WAS * dMul : total;
          dNow = DP_NOW > 0 ? DP_NOW * dMul : total;
        }
        /* Two guards the modes can't enforce on their own. A deal bar must never quote MORE than the
           shopper is actually charged: once a bulk tier kicks in it can beat a typed per-carton price, and
           past that point the honest thing is to fall back to the real total — which is the better deal
           anyway. And a struck figure below the price it sits beside reads as a bug, so it floors there. */
        if (dNow < 0) dNow = 0;
        if (dNow > total) dNow = total;
        if (dWas < dNow) dWas = dNow;
        var dGap = dWas - dNow;
        dtNow.textContent = money(dNow);
        if (dtWas) { if (dGap > 1) { dtWas.textContent = money(dWas); dtWas.hidden = false; } else { dtWas.hidden = true; } }
        if (dtSave) { if (dGap > 1) { dtSave.textContent = SAVE_WORD + ' ' + money(dGap); dtSave.hidden = false; } else { dtSave.hidden = true; } }
      }
      if (dsOut) {
        if (cpd > 0) {
          var days = supplyDays(qty, cpd);
          dsOut.innerHTML = '<b>' + (qty * CHEWS) + ' chews</b> · your dog: <b>' + days + '-day supply</b>'
            + ' <span class="ds-hint">(' + cpd + ' chew' + (cpd > 1 ? 's' : '') + '/day)</span>';
        } else if (minCpd !== maxCpd) {
          dsOut.innerHTML = '<b>' + (qty * CHEWS) + ' chews</b> · lasts <b>' + supplyDays(qty, maxCpd) + '–' + supplyDays(qty, minCpd) + ' days</b>'
            + ' <span class="ds-hint">— pick a size for your dog\'s number</span>';
        } else {
          dsOut.innerHTML = '<b>' + (qty * CHEWS) + ' chews</b> · <b>' + supplyDays(qty, minCpd) + '-day supply</b>';
        }
      }
      var ppo = $('[data-plan-price-once]'), pps = $('[data-plan-price-sub]'), pws = $('[data-plan-was-sub]');
      var oTotal = Math.round(BASE * qty * (1 - off));
      if (ppo) ppo.textContent = money(oTotal);
      if (pps) pps.textContent = money(Math.round(oTotal * (1 - SUB_OFF)));
      if (pws) pws.textContent = money(oTotal);
      if (atcPrice) atcPrice.textContent = ' · ' + money(total);
      if (psPrice) psPrice.textContent = money(total);
      if (psWas) { if (save > 1) { psWas.textContent = money(was); psWas.hidden = false; } else psWas.hidden = true; }
      if (psMeta) psMeta.textContent = qty + (qty > 1 ? ' cartons' : ' carton') + (plan === 'sub' ? ' · subscription' : '');
    }

    /* ADD TO CART (AJAX → theme cart drawer, native-form fallback) */
    var form = $('.buy-form') || $('#hh-product-form');
    var atcBtn = $('[data-atc]');
    function addToCart() {
      if (!form) return;
      // Shared helper (assets/hh-common.js): AJAX add + re-render the theme cart count/drawer
      // + open it + loader/success states. Fixes the stale-drawer gap of a bare fetch.
      if (window.HH && typeof window.HH.cartAdd === 'function') { window.HH.cartAdd(form, atcBtn); return; }
      form.submit();  // fallback: native add if the shared helper hasn't loaded yet
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });

    /* APPSTLE SUBSCRIPTIONS — the app auto-injects its widget near the add-to-cart button.
       Move it into the themed slot ABOVE "how many cartons?" (kept inside the form so the
       selected plan still submits). Robust to late mount / re-injection on variant change. */
    (function () {
      var slot = $('.buy-sub-slot');
      if (!slot) return;
      var SEL = '.appstle_subscription_wrapper, [class*="appstle_subscription_wrapper"], [id^="appstle_subscription_widget"], appstle-subscription-widget';
      function place() {
        var w = root.querySelector(SEL);
        if (w && w.parentElement !== slot) slot.appendChild(w);
      }

      /* Appstle prints an "Attention — this preview is a mockup…" notice above its widget when it can't
         resolve the live one, which is every `shopify theme dev` / theme-editor session. It is a preview
         artefact, never rendered on the storefront, but it sat between the divider and "Purchase Options"
         and read like part of the buy box. Matched on its own text and scoped to the app slots, so the
         rule can only ever hit that banner — the live widget carries no such string. */
      function stripPreviewNotice() {
        try {
          Array.prototype.forEach.call(root.querySelectorAll('.buy-app'), function (box) {
            var els = box.querySelectorAll('*');
            for (var i = 0; i < els.length; i++) {
              var t = els[i].textContent || '';
              if (t.indexOf('is a mockup') === -1) continue;
              if (t.length > 400) continue;   // still the widget wrapper — keep descending
              els[i].hidden = true;           // document order, so this is the notice's own box
              return;
            }
          });
        } catch (e) {}
      }

      function sync() { place(); stripPreviewNotice(); }
      sync();
      try { new MutationObserver(sync).observe(root, { childList: true, subtree: true }); } catch (e) {}
      [300, 900, 2000, 4000].forEach(function (t) { setTimeout(sync, t); });
    })();
    var psBtn = $('[data-ps-btn]'); if (psBtn) psBtn.addEventListener('click', addToCart);

    /* EMAIL capture — REAL Shopify signup. The field + button are bound (via form="") to the hidden
       {% form 'customer' %} rendered next to the product form, so we listen on THAT form, not on the
       button: Enter-in-the-field and click both land here, and native validation has already passed.
       HH.subscribe posts it to /contact without a reload; if the helper is missing we don't intercept
       at all and the browser posts natively, and if the request itself fails we hand it back to the
       browser the same way — an address is never silently dropped. */
    var bseWrap = $('[data-bse-form]'), bseEmail = $('[data-bse-email]');
    var bseForm = bseEmail && bseEmail.form;
    // A browser that ignored form="" would resolve .form to the enclosing PRODUCT form — never bind there,
    // or we'd intercept add-to-cart. Only the hidden customer form is a valid target.
    if (bseForm && (bseForm === form || !bseForm.classList.contains('bse-shadow-form'))) bseForm = null;
    if (bseWrap && bseForm) {
      var bseBtn = $('[data-bse-submit]');
      var bseDone = $('[data-bse-done]'), bseErr = $('[data-bse-error]');
      var bseBusy = false;
      var bseFail = function (msg) { if (bseErr) { bseErr.textContent = msg; bseErr.removeAttribute('hidden'); } };
      bseForm.addEventListener('submit', function (e) {
        if (bseBusy) { e.preventDefault(); return; }
        if (!window.HH || typeof window.HH.subscribe !== 'function') return;   // no helper → native POST
        e.preventDefault();
        bseBusy = true;
        if (bseErr) { bseErr.setAttribute('hidden', ''); bseErr.textContent = ''; }
        if (window.HH.btnLoading) window.HH.btnLoading(bseBtn, true);

        window.HH.subscribe(bseForm).then(function (res) {
          bseBusy = false;
          if (window.HH.btnLoading) window.HH.btnLoading(bseBtn, false);
          if (res.ok) {
            bseWrap.setAttribute('hidden', '');
            if (bseDone) bseDone.removeAttribute('hidden');
            return;
          }
          bseFail(res.message || 'that email didn’t go through — mind checking it?');
        }).catch(function () {
          bseBusy = false;
          if (window.HH.btnLoading) window.HH.btnLoading(bseBtn, false);
          try { bseForm.submit(); } catch (err) { bseFail('couldn’t sign you up just now — please try again.'); }
        });
      });
    }

    /* (The feature ticks used to collapse behind a mobile "view all (n)" toggle to keep add-to-cart above
       the fold. The ticks now render below the checkout block, so there is no fold to buy back and every
       tick is simply visible — the toggle, its markup and its CSS are gone with it.) */

    /* ACCORDIONS */
    $$('[data-acc-item]').forEach(function (item) {
      var q = item.querySelector('[data-acc-q]'), a = item.querySelector('[data-acc-a]');
      q.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
      if (item.classList.contains('is-open')) a.style.maxHeight = a.scrollHeight + 'px';
      q.addEventListener('click', function () { var open = item.classList.contains('is-open'); item.classList.toggle('is-open', !open); q.setAttribute('aria-expanded', String(!open)); a.style.maxHeight = open ? null : a.scrollHeight + 'px'; });
    });

    /* DEAL TIMER — a short countdown (minutes, from [data-dt-mins]) replacing the original countdown to
       midnight (~9 hours, no urgency). The deadline is stored in localStorage, so a reload or a move
       between products RESUMES the same clock instead of handing out a fresh one. It rolls over to a new
       window only when it actually reaches 00:00:00. */
    var dtH = $('[data-dt-h]'), dtM = $('[data-dt-m]'), dtS = $('[data-dt-s]');
    if (dtH && dtM && dtS) {
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var host = dtH.closest('.deal-timer');
      var mins = host ? parseInt(host.getAttribute('data-dt-mins'), 10) : 0;
      if (!mins || mins < 1) mins = 6;
      var WIN = mins * 60000, KEY = 'hh_deal_until';
      var store = function (v) { try { localStorage.setItem(KEY, String(v)); } catch (e) {} };
      var deadline = 0;
      try { deadline = parseInt(localStorage.getItem(KEY), 10) || 0; } catch (e) {}
      var now0 = new Date().getTime();
      // Resume the saved clock; only start a new window if there isn't one or it has already run out.
      if (!deadline || now0 >= deadline) { deadline = now0 + WIN; store(deadline); }
      var tick = function () {
        var now = new Date().getTime();
        if (now >= deadline) { deadline = now + WIN; store(deadline); }   // hit zero -> roll straight over
        var s = Math.max(0, Math.floor((deadline - now) / 1000));
        dtH.textContent = pad(Math.floor(s / 3600)); s %= 3600;
        dtM.textContent = pad(Math.floor(s / 60));
        dtS.textContent = pad(s % 60);
      };
      tick(); setInterval(tick, 1000);
    }

    /* STICKY */
    var sticky = $('[data-sticky]'), buySec = root;
    if (sticky) {
      var ticking = false;
      var onScroll = function () { if (ticking) return; ticking = true; requestAnimationFrame(function () { var bottom = buySec.getBoundingClientRect().bottom; sticky.classList.toggle('show', bottom < 120); ticking = false; }); };
      window.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onScroll, { passive: true }); onScroll();
    }

    render();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('.hh-product-hero'), initHero); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var el = e.target.querySelector ? e.target.querySelector('.hh-product-hero') : null; if (el) { el.dataset.hhInit = ''; initHero(el); } });
})();
